<template>
  <div class="w-full flex flex-col items-center justify-center md:max-w-[960px] text-center">
    <PrettyDocumentHeader :title :subtitle :colors :background-image/>
    <FramedContainer v-if="backgroundImage || content" :colors="colors" :backgroundVariant="1" class="w-full  z-10 px-5">
      <div class="w-full min-h-[200px] flex flex-col relative">
        <img v-if="backgroundImage || backgroundImage.url !== ''"
            :src="resolveMediaUrl(backgroundImage.url)" v-bind="imgAttrs(resolveMediaUrl(backgroundImage.url), '100vw')"
            class="w-full inset  object-cover"
            :alt="alt"
        />
        <div v-if="content" class="absolute inset p-10 bg-linear-to-b from-black/20 to-black/90 italic font-thin text-white text-2xl w-full h-full flex flex-col items-center justify-end">
          {{content}}
        </div>
      </div>
    </FramedContainer>
  </div>
</template>

<script setup>
import {imgAttrs} from "@/utils/photoSizes.js";
import {useRouter} from "vue-router";
import {computed, onMounted, ref} from "vue";
import FramedContainer from "@/components/FramedContainer.vue";
import PrettyDocumentHeader from "@/components/PrettyDocumentHeader.vue";
import {resolveMediaUrl} from "@/composables/images.js";
import {useBackLinks} from "@/composables/useBackLinks.js";
const back = useBackLinks();

const router = useRouter();
const isClient = ref(false);

onMounted(() => {
  isClient.value = true;
  cachedNavHeight.value = document.querySelector("nav")?.offsetHeight || 0;
});

const props = defineProps({
  title: {type: String, required: true},
  subtitle: {type: String, required: true},
  content: {type: String, required: false},
  backgroundImage: {type: String, default: ""},
  backgroundVideo: {type: String, default: ""}, // ✅ New prop for video support
  alt: {type: String, default: "hero image"},
  overlayOpacity: {type: Number, default: 0.4},
  callToAction: {type: String, default: ""},
  scrollTarget: {type: String, default: ""},
  navigateTo: {type: String, default: ""},
  fullHeight: {type: Boolean, default: false},
  colors: {type: Object, required: true}
});

const cachedNavHeight = ref(0);

const cssVars = computed(() => ({
  "--light-variant-1": "var(--brand-whitest)",
  "--light-variant-2": "var(--brand-lightest)",
  "--light-variant-3": "var(--brand-light)",
  "--dark-variant-1": "var(--brand-dark)",
  "--dark-variant-2": "var(--brand-darkest)",
  "--primary-color": "var(--brand-primary)",
  "--accent-color": "var(--brand-accent)",
  "--link-color": "var(--brand-accent)",
  "--link-hover-color": "var(--brand-accent-dark)"
}));

const callToActionClicked = () => {
  if (props.scrollTarget) {
    const targetElement = document.getElementById(props.scrollTarget);
    if (targetElement) {
      window.scrollTo({
        top: targetElement.offsetTop - cachedNavHeight.value,
        behavior: "smooth"
      });
    }
  } else if (props.navigateTo) {
    router.push(back(props.navigateTo));
  }
};
</script>
